var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right" }, [
    _c("div", { ref: "top", staticClass: "top" }, [
      _c("span", [_vm._v("已选择(" + _vm._s(_vm.list.length) + "/1000)")]),
      _c("span", { on: { click: _vm.deleteAll } }, [
        _c("i", { staticClass: "el-icon-delete" }),
        _vm._v("清空"),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "list", style: { height: _vm.listHeight } },
      [
        _c(
          "dsf-virtual-scroll",
          { attrs: { "scroll-x": "" } },
          _vm._l(_vm.list, function (li, i) {
            return _c("result-li", { key: li.id, attrs: { li: li, index: i } })
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }